import React from 'react';
import { Users, Calendar, Image } from 'lucide-react';
import { features as mockFeatures } from '../mock';
import { Card, CardContent } from './ui/card';
import { useSiteContent } from '../contexts/SiteContentContext';

const iconMap = {
  users: Users,
  calendar: Calendar,
  image: Image
};

const FeatureCard = ({ feature }) => {
  const Icon = iconMap[feature.icon];

  return (
    <Card className="group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border-none bg-white h-full">
      <CardContent className="p-8 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-[#FF1B6D]/10 rounded-full mb-6 group-hover:bg-[#FF1B6D] transition-colors duration-300">
          <Icon
            size={40}
            className="text-[#FF1B6D] group-hover:text-white transition-colors duration-300"
          />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          {feature.title}
        </h3>
        <p className="text-gray-600 leading-relaxed">
          {feature.description}
        </p>
      </CardContent>
    </Card>
  );
};

export const FeaturesSection = () => {
  const content = useSiteContent();

  // Use admin features if available, fallback to mock
  const features = (content?.features && content.features.length > 0)
    ? content.features.map((f, i) => ({ ...f, id: i + 1, icon: f.icon || mockFeatures[i]?.icon || 'users' }))
    : mockFeatures;

  return (
    <section id="apropos" className="py-20 lg:py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            Pourquoi Nous Choisir
          </h2>
          <div className="h-1 bg-[#FF1B6D] mx-auto" style={{width: '6rem'}} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature) => (
            <FeatureCard key={feature.id} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};